import { useCallback, useState } from 'react';
import { fetchCompanyData, validateYTunnus } from '../../services/ytjService';

export function useYTunnusLookup() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const lookup = useCallback(async (yTunnus) => {
    if (!validateYTunnus(yTunnus)) {
      return null;
    }
    setLoading(true);
    setError(null);
    try {
      const companyData = await fetchCompanyData(yTunnus);
      return {
        companyName: companyData.companyName,
        address: companyData.address,
        website: companyData.website,
      };
    } catch (err) {
      setError(err.message || 'Virhe haettaessa yrityksen tietoja.');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return { lookup, loading, error, setError, validateYTunnus };
}
